import React from 'react'
import { hot } from 'react-hot-loader'
import Homepage from './Homepage'
import { VolnyEmail } from '../components/widgets/Email'
import { LAYOUT_SECTIONS, WIDGETS } from '../constants'

class Volny extends Homepage {
  getDynamicWidgets () {
    const {
      props: {
        widgets: {
          email
        }
      },
      state: {
        containers: {
          inbox
        }
      }
    } = this

    return Object.assign({}, super.getDynamicWidgets(), {
      [WIDGETS.HOMEPAGE.EMAIL]: () => <VolnyEmail widget={email} container={inbox}/>
    })
  }

  getDesktopWidgetsLayout () {
    const layout = super.getDesktopWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO
    ]

    return layout
  }

  getTabletWidgetsLayout () {
    const layout = super.getTabletWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO
    ]

    return layout
  }

  getMobileWidgetsLayout () {
    const layout = super.getMobileWidgetsLayout()
    layout[LAYOUT_SECTIONS.OUTSIDE_CONTENT] = [
      WIDGETS.HOMEPAGE.NATIVE_APP_PROMO,
      WIDGETS.COMMON.SMART_ADVERT_4
    ]

    return layout
  }
}

export default hot(module)(Volny)
